import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { ModalGenericoModel } from 'src/app/shared/models/modal.model';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TipoRnt } from 'src/app/shared/enumeraciones/tipo-rnt.enum';
import { TipoPrestador } from 'src/app/shared/enumeraciones/tipo-prestador.enum';
import { AuthService } from 'src/app/shared/services/auth.service';

@Component({
	selector: 'app-modal-seleccion-tipo-rnt',
	templateUrl: './modal-seleccion-tipo-rnt.component.html',
	styleUrls: ['./modal-seleccion-tipo-rnt.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class ModalSeleccionTipoRntComponent implements OnInit {
	@Input()
	verificacionGuia: number;
	modalGenerico: ModalGenericoModel;
	tipo_rnt_guia = TipoRnt.Guia;
	tipo_rnt_esblecimiento = TipoRnt.Establecimiento;
	tipo_rnt_inmueble = TipoRnt.Inmuebles;
  tipo_rnt_plataforma = TipoRnt.PlataformaDigitales;
	tipo_prestador_guia = TipoPrestador.Guia;
	seleccionado: TipoRnt;
  show_tipo_plataforma: boolean = false;

	constructor(private activeModal: NgbActiveModal, public authService: AuthService) { }

	ngOnInit() {
		this.modalGenerico = {
			titulo: 'Seleccione el tipo de RNT'
		};

    console.log('%cmodal-seleccion-tipo-rnt.component.ts line:34 tipo prestador id', 'color: #007acc;', this.authService.getRolDetalleUser());
    if(this.authService.getRolDetalleUser() === "2" ){
      this.show_tipo_plataforma = true;
    }
	}

	confirm(): void {
		if (this.activeModal) {
			this.activeModal.close(this.seleccionado);
		}
	}

	selecionarDato(tipo_rnt_id: TipoRnt) {
		this.seleccionado = tipo_rnt_id;
	}

	dismiss(): void {
		if (this.activeModal) {
			this.activeModal.dismiss();
		}
	}
}
